  <!-- INDICE -->
<!--   <app-table-of-content [sections]="sections" (selection)="scrollIntoView($event)"></app-table-of-content> -->

<!-- TRANSPORTE EN ESPAÑA - INTRO -->
<span #dynamicElement id="intro"></span>
<app-app-section [sectionInfo]="cardIntro"></app-app-section>

<!-- Photo by <a href="https://unsplash.com/@emrecan_arik?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">emrecan arık</a> on <a href="https://unsplash.com/photos/people-standing-on-white-train-w0lOjzINXQk?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->
<!-- MOBILITY APPS -->
<span #dynamicElement id="appsMobility"></span>

<app-card-image-overlay [cardInfo]="transportImageCard"></app-card-image-overlay>
<app-section-post-list-img [sectionInfo]="mobilityApps"></app-section-post-list-img>

<!-- Photo by <a href="https://unsplash.com/@javierezpeleta?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Javier Ezpeleta</a> on <a href="https://unsplash.com/photos/red-and-black-street-sign-jYmUxLbF1wE?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a> -->

<!-- <div #dynamicElement id="mapasmetro"></div>
<h2 class="webapp-title-secondary">Mapas de metro</h2>
<div class="medium-gray-title">Guías en PDF de los metros de Madrid, Barcelona y Valencia</div>

<app-slider-horizontal  [items]="metroMaps" [itemTemplate]="artistCardTemplate"></app-slider-horizontal> -->

<ng-template #artistCardTemplate let-map>
  <app-card-pdf-guide [city]="map.city" [image]="map.imageUrl" [link]="'map.link'" [id]="map.id"></app-card-pdf-guide>
</ng-template>

<!-- CANJE DE LICENCIA -->

<!-- Explicación pasos
​​https://sede.dgt.gob.es/es/permisos-de-conducir/canjes-de-permisos/canjes-de-permisos-extranjeros/canjes-de-terceros-paises-con-convenio/?pais=cr


CITA
https://sedeclave.dgt.gob.es/WEB_NCIT_CONSULTA/solicitarCita.faces


Países con convenio
https://www.dgt.es/nuestros-servicios/permisos-de-conducir/permisos-extranjeros-y-de-fuerzas-y-cuerpos-de-seguridad/canjes-de-permisos/paises-con-convenio-de-canjes/ -->


<!-- TAXI -->
<!-- <div>
  <h1 class="webapp-title">Taxis en España</h1>
  <p>Taxis in Spain are a convenient way to get around. Here is some useful information:</p>
  <ul>
    <li>Taxis are available in all major cities and can be hailed on the street or booked via phone or app.</li>
    <li>Popular taxi apps include Free Now and Cabify.</li>
    <li>Most taxis accept cash and credit/debit cards.</li>
    <li>Always check for the official taxi sign and meter.</li>
  </ul>
  <div #dynamicElement id="taxi"></div>
  <app-section-post-list-img [sectionInfo]="taxiApps"></app-section-post-list-img>
</div> -->

<!-- FLIGHTS -->
<!-- <h1 class="webapp-title">Vuelos</h1>
<div #dynamicElement id="vuelos"></div> -->
<!-- <p>Tips for finding the best deals:</p>
<ul>
  <li>Book in advance to get the best prices.</li>
  <li>Be flexible with your travel dates.</li>
  <li>Use price alerts to track fare changes.</li>
</ul> -->
<app-section-post-list-img [sectionInfo]="flightWebsites"></app-section-post-list-img>

<!-- PRECIOS Y DESCRIPCION -->
<div #dynamicElement id="tarifas"></div>
<h1 class="webapp-title">Tarifas</h1>
<div class="medium-gray-title">Precios orientativos del transporte público en Madrid y Barcelona</div>
<div>
    <table>
        <tr>
            <th>Tipo de billete/abono</th>
            <th>Madrid</th>
            <th>Barcelona</th>
        </tr>
        <tr>
            <td>Billete sencillo (metro/bus)</td>
            <td>€1.50 - €2.00</td>
            <td>€2.40 (Zona 1)</td>
        </tr>
        <tr>
            <td>Tarjeta Multi (10 viajes)</td>
            <td>€12.20 - €18.30</td>
            <td>€27.20 (Zona 1)</td>
        </tr>
        <tr>
            <td>Abono mensual joven (zonas A-B1)</td>
            <td>€20.00 - €35.00</td>
            <td>€40.00 - €54.00</td>
        </tr>
        <tr>
            <td>Abono mensual normal (zonas A-B1)</td>
            <td>€54.60 - €63.00</td>
            <td>€54.00 - €79.45</td>
        </tr>
        <tr>
            <td>Tarjeta Joven (anual)</td>
            <td>€20.00 (solicitud) + descuentos en viajes</td>
            <td>€105.00 (solicitud) + descuentos en viajes</td>
        </tr>
        <tr>
            <td>Tarjeta T-Jove (anual)</td>
            <td>-</td>
            <td>€105.00 (para menores de 25 años)</td>
        </tr>
        <tr>
            <td>Abono transporte (mensual, todas las zonas)</td>
            <td>€43.00 - €126.00</td>
            <td>€40.00 - €148.50</td>
        </tr>
    </table>
</div>

<!-- City Selection Section -->
<!-- <div class="section city-selection">
  <h3>Select Your City</h3>
  <div class="btn-group btn-group-toggle" data-toggle="buttons">
    <label class="btn btn-primary shadow-sm" *ngFor="let city of cities" (click)="selectCity(city)">
      <input type="radio" name="options" id="option1" [checked]="selectedCity === city"> {{ city }}
    </label>
  </div>
</div> -->

<!-- Public Transport Section -->
<div class="section public-transport" *ngIf="selectedCity">
  <h3>Public Transport in {{ selectedCity }}</h3>
  <div class="accordion" id="publicTransportAccordion">
    <div class="card shadow-sm" *ngFor="let transport of publicTransport[selectedCity]">
      <div class="card-header" id="heading{{ transport.id }}">
        <h2 class="mb-0">
          <button class="btn btn-link text-dark" type="button" data-toggle="collapse" [attr.data-target]="'#collapse' + transport.id" aria-expanded="true" [attr.aria-controls]="'collapse' + transport.id">
            {{ transport.name }}
          </button>
        </h2>
      </div>
      <div [id]="'collapse' + transport.id" class="collapse" [attr.aria-labelledby]="'heading' + transport.id" data-parent="#publicTransportAccordion">
        <div class="card-body">
          {{ transport.description }}
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Tickets and Passes Section -->
<div class="section tickets-passes" *ngIf="selectedCity">
  <h3>Tickets and Passes</h3>
  <div class="card-deck">
    <div class="card shadow-sm" *ngFor="let ticket of tickets[selectedCity]">
      <div class="card-body">
        <h5 class="card-title">{{ ticket.name }}</h5>
        <p>{{ ticket.description }}</p>
        <p><small class="text-muted">{{ ticket.price }}</small></p>
      </div>
    </div>
  </div>
</div>

<!-- Download Metro Maps Section -->
<!-- <div class="section download-maps" *ngIf="selectedCity">
  <h3>Download Metro Maps</h3>
  <div class="list-group">
    <a *ngFor="let map of metroMaps[selectedCity]" [href]="map.link" class="list-group-item list-group-item-action shadow-sm" target="_blank">
      {{ map.city }} Metro Map
    </a>
  </div>
</div> -->
    
<!-- Prices Section -->
<div class="section prices" *ngIf="selectedCity">
  <h3>Prices</h3>
  <ul>
    <li *ngFor="let price of prices[selectedCity]">{{ price.item }}: {{ price.cost }}</li>
  </ul>
</div>

<!-- Map Section -->
<!-- <div class="section map">
  <h3>Transport Map</h3>
  <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" class="w-100 shadow-sm">
    <agm-marker [latitude]="lat" [longitude]="lng" [label]="'A'"></agm-marker>
    <agm-marker *ngFor="let location of locations" [latitude]="location.lat" [longitude]="location.lng" [label]="location.label"></agm-marker>
  </agm-map>
</div> -->

<!-- Distance Calculation Section -->
<div class="section distance-calculation" *ngIf="selectedCity">
  <h3>Calculate Distances</h3>
  <form (submit)="calculateDistances()">
    <div class="form-group">
      <label for="origin">Enter your starting point:</label>
      <input type="text" class="form-control shadow-sm" id="origin" [(ngModel)]="origin" name="origin" required>
    </div>
    <button type="submit" class="btn btn-primary shadow-sm">Calculate</button>
  </form>
  <div *ngIf="distances.length > 0">
    <h4>Distances from {{ origin }}</h4>
    <ul>
      <li *ngFor="let distance of distances">{{ distance.place }}: {{ distance.km }} km</li>
    </ul>
  </div>
</div>